import React, { useState } from "react";
import { Button, TextField, MenuItem } from "@mui/material";
import authAxios from "../../authAxios";
import { useGlobalState } from "../../GlobalStates";

const TempAccountMerge = () => {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [extension, setExtension] = useState("+886");
  const [user, setUser] = useGlobalState("user");

  const handleTempTwMerge = async () => {
    try {
      const res = await authAxios.post("/v1/user/tempMergeTwLine", {
        email,
        extension,
        phone,
        existingUserToDelete: user,
      });

      if (res.status == 200) {
        localStorage.setItem("USER_ID", res.data.user.id);
        localStorage.setItem("JWT_TOKEN", res.data.token);
        setUser(res.data.user);
        alert("成功，請下載我們的應用程式並再次使用 LINE 登入以完成帳戶合併");
      } else {
        alert("合併失敗");
      }
    } catch (error) {
      alert("合併失敗");
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "300px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
          height: "20rem",
        }}
      >
        <TextField
          label="電子郵件"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          variant="outlined"
          fullWidth
          margin="normal"
        />
        <div style={{ display: "flex", alignItems: "center", marginBottom: "16px" }}>
          <TextField
            label="區碼"
            value={extension}
            onChange={(e) => setExtension(e.target.value)}
            variant="outlined"
            style={{ width: "150px", marginRight: "8px" }}
            select
          >
            <MenuItem value="+886">+886</MenuItem>
          </TextField>
          <TextField
            label="電話號碼"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            variant="outlined"
            fullWidth
          />
        </div>
        <Button variant="contained" color="primary" onClick={handleTempTwMerge}>
          合併
        </Button>
      </div>
    </div>
  );
};

export default TempAccountMerge;
